import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

import { schoolYearsResponseSchema, type SchoolYearsResponse } from '../lib/schoolYear.schema';

export type GetSchoolYearsParams = {
  redeId?: string;
  escolaId?: number;
  anoLetivo?: string;
};

export const getSchoolYears = httpGetAdapter<SchoolYearsResponse, GetSchoolYearsParams>({
  url: '/v3/dashboard/resultado/ano-escolar',
  schema: schoolYearsResponseSchema,
  mapParams: (params) => ({
    redeId: params.redeId,
    escolaId: params.escolaId,
    anoLetivo: params.anoLetivo,
  }),
});
